module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thanks"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Спасибо!")]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "notice"
  }, [_vm._v("Ваша идея появится в общем списке после модерации")]), _vm._v(" "), _c('div', {
    staticClass: "button-to-ideas"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'ideas'
      }
    }
  }, [_vm._v("Смотреть все идеи")])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-to-idea-create"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'idea-create'
      }
    }
  }, [_vm._v("Добавить ещё идею")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eb06868","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thanks.vue
// module id = 115
// module chunks = 0